import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-662270bb")

_pushScopeId("data-v-662270bb")
const _hoisted_1 = {
  id: "loading",
  class: "flex flex-col justify-center items-center"
}
const _hoisted_2 = {
  key: 0,
  class: "text-2xl font-bold text-center py-5"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { id: "text" }, "Made in Labs, Backed by Science", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loadingText)
      ? (_openBlock(), _createBlock("h2", _hoisted_2, _toDisplayString(_ctx.loadingText), 1))
      : _createCommentVNode("", true),
    _createVNode("div", {
      id: "background",
      class: `py-6 px-4 text-3xl font-bold ${_ctx.animate ? 'animate' : ''}`
    }, [
      _hoisted_3
    ], 2)
  ]))
})